import { render } from "./Result.vue?vue&type=template&id=5bd0c321&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=5bd0c321&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd0c321"]])

export default __exports__